export const environment = {
  verboseLogging: true,
  production: false,
  signInAllowed: true,
  auth: {
    clientId: 'dev-webapp',
    authority: 'https://auth.fsmb.rwth-aachen.de/realms/unicup',
    redirectUri: 'https://kvv-pos-dev.unicup.rwth-aachen.de/loginRedirect',
  },
  api: {
    backendBaseUrl: 'https://dev.unicup.rwth-aachen.de/api',
    pushMonkeyBaseUrl: 'https://dev.unicup.rwth-aachen.de/push',
  },
};
